<template>
  <div class="input-with-del-btn">
    <b-form-input :id="id" :name="name" :disabled="disabled" :required="required" :readonly="readonly" :autocomplete="autocomplete" :aria-required="ariaRequired" :aria-invalid="ariaInvalid" v-model="inputVal" :type="type" :value="value">
    </b-form-input> <i v-if="inputVal !== null && inputVal !== ''" class="fa fa-times" aria-hidden="true" @click="clearVal"></i>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: true,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    autocomplete: {
      type: String,
      required: false,
      default: null
    },
    ariaRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    ariaInvalid: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      inputVal: this.value
    }
  },
  watch: {
    inputVal (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    clearVal () {
      this.inputVal = null
    }
  }
}
</script>

<style scoped>
  .input-with-del-btn {
    position: relative;
  }
  .input-with-del-btn .fa-times {
    top: 9px;
    right: 10px;
    cursor: pointer;
    position: absolute;
    color: #888;
    text-align: center;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/forms/TextInputDelBtn.vue